import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { authLogin } from '../../services/authService';

const LoginPage = () => {
    const [error, setError] = useState('');
    
    const navigate = useNavigate();
    const handleSuccess = async (response) => {
        try {
          const idToken = response?.credential;
          if (!idToken) {
            console.error('No ID token received');
            return;
          }

          const backendResponse = await authLogin(idToken);

          if (backendResponse?.token) {
            localStorage.setItem('token', backendResponse.token);
            navigate('/admin');
          } else {
            setError('No token received from backend');
          }
        } catch (err) {
          console.error('Login failed:', err);
        }
      };

    return (
        <div className="flex justify-center items-center min-h-[50vh]">
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
              <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Admin Login</h2>

              <div className="w-full flex items-center justify-center gap-2 py-2 px-4 bg-white">
                <GoogleLogin onSuccess={handleSuccess} onError={() => console.error('Google login failed')} />
              </div>
              {error && <p className="mt-4 text-sm text-red-600 text-center">{error}</p>}
            </div>
        </div>
    );
};

export default LoginPage;